import styled from 'styled-components';
import React, { ChangeEvent, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash-es';
import { CustomTable } from '@dev/ee-components';
import { HistoryBackActionContext, useHistoryBackAction } from '@/services/hooks/useHistoryBackAction';
import { PreviewOverlay } from '@/components/TemplatePreviewComponent/WebsiteMode/PreviewOverlay';
import {
    getCheckoutsStore,
    PickCheckouts,
} from '@/store/checkouts/actions';
import { useTableHeaders } from '../../hooks/useTableHeaders/index';
import { TableFilters } from '../../components/TableFilters/index';
import { useTableRows } from '../../hooks/useTableRows';


const TableContainer = styled.div`
    margin-top: 32px;
`;

const columnWidth: Record<string, string> = {
    checkoutPreview: '145px',
    checkoutName: '60%',
    status: '134px',
    viewoptions: '146px',
};

interface PreviewContent {
    name?: string;
    content?: string;
}

export const CheckoutsTable = (): JSX.Element => {
    const checkouts = useSelector(getCheckoutsStore);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isSavedRef = React.useRef(true);
    const historyBackAction = useHistoryBackAction({isSavedRef})
    const [previewContent, setPreviewContent] = useState<PreviewContent>(null);
    const headers = useTableHeaders();
    const rows = useTableRows(setPreviewContent);

    const pickCheckout = (event: ChangeEvent<unknown>, pickedCheckouts: string[]) => {
        event?.stopPropagation?.();
        event?.preventDefault?.();

        dispatch(PickCheckouts(pickedCheckouts));
    };
 
    const onPreviewClose = (): boolean => {
        setPreviewContent(null);
        return true;
    };

    return (
        <HistoryBackActionContext.Provider value={historyBackAction}>
            <TableContainer>
                <TableFilters />
                <CustomTable
                    headers={headers}
                    rows={rows}
                    isEmpty={isEmpty(checkouts?.templatesList) && !checkouts?.loadingTemplates}
                    loading={checkouts?.loadingTemplates}
                    stickyHeader
                    rowPadding={48}
                    rowHeight={60}
                    columnsWidth={columnWidth}
                    emptyStateProps={{ text: t('emptystate') }}
                    disableFirstRowBorderTop
                    onSelectRow={pickCheckout}
                    selectedRows={checkouts.checkedCheckouts}
                    isHeaderCheckboxEnabled
                    disableRowClick
                />
            </TableContainer>
            {previewContent && (
                <PreviewOverlay
                    name={previewContent.name}
                    previewContent={previewContent.content}
                    onClose={onPreviewClose}
                    fullWidthContent={true}
                />
            )}
        </HistoryBackActionContext.Provider>
    );
};